import React, { useEffect } from 'react';
import { Row, Col, Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';

import { VerificaRota } from '../../../services/VerificaSePodeAcessar';
import LayoutDashboard from '../../../layout/LayoutAdmin';
import { AbaCongelamento } from './AbaCongelamentoUnicoCNPJ';
import { AbaImportantes } from './AbaCongelamentoEmLote';

const { TabPane } = Tabs;

const CertidoesCongelamentos: React.FC = () => {

    const navigate = useNavigate();

    useEffect(() => {

        let arrayUrl = window.location.pathname.split("/");
        VerificaRota(arrayUrl, navigate);

    }, []);

    return (
        <LayoutDashboard>
            <Row>
                <Col span={24}>
                    <Tabs
                        type="card"
                        defaultActiveKey="congelamentos"
                        className='tab-municipios'
                    >
                        <TabPane
                            tab="Congelamento único por CNPJ"
                            key="congelamentos"
                        >
                            <AbaCongelamento />
                        </TabPane>
                        <TabPane
                            tab="Congelamento em lote"
                            key="importacoes"
                        >
                            <AbaImportantes />
                        </TabPane>

                    </Tabs>
                </Col>
            </Row>

        </LayoutDashboard>
    );
}

export default CertidoesCongelamentos;
